import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing the filter view for casino reports.
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing a date picker
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange', // CSS class for styling
                    readonly: true, // Make the input read-only
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Center-left section containing a product selection dropdown
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting products
                    name: 'ProductId',
                    localId: 'product:combo', // Local ID for referencing
                    label: _('Producto'), // Label for the dropdown
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown
                },
            ],
        };

        // Center-right section containing a provider selection dropdown
        const center_right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting providers
                    name: 'ProviderId',
                    localId: 'provider:combo', // Local ID for referencing
                    label: _('Proveedor'), // Label for the dropdown
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown
                },
            ],
        };

        // Right section containing a test selection dropdown
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting test status
                    name: 'IsTest',
                    localId: 'isTest:combo', // Local ID for referencing
                    label: _('Es Test'), // Label for the dropdown
                    labelPosition: 'top', // Position of the label
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown
                },
            ],
        };

        // Upper section combining all the left, center, and right sections
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_right,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Buttons section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Button label
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        this.getRoot().clear(); // Clear the form values
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'), // Button label
                    type: 'form', // Type indicating form submission
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event with values
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
